import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
// import videoSource from "../../assets/videos/CB.mp4";
// import videoSource1 from "../../assets/videos/ST_Demo.mp4";
// import architecture from "../../assets/images/resource/rag_arc.jpeg";
import architecture2 from "../../assets/images/resource/rag_arc2.png";
import FooterOne from "../Footer/FooterOne";
import SorBanner from "./../../assets/images/banner/ai-agents.png";
// import cb from "./../../assets/images/icons/cb.jpg";
// import msa from "./../../assets/images/icons/msa.png";

const Rag = () => {
  pageTitle("RAG");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div
        className="ai-overlay-wrapper"
        style={{ backgroundImage: `url(${SorBanner})` }}
      >
        {/* <img src={SorBanner} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          {/* Centered text */}
          {/* <img
            src={msa}
            alt="Microsoft azure"
            className="ai-overlay-corner-img"
          /> */}
          <div className="ai-overlay-center-text">
            <h2 className="aai-h2 mt-0">RAG Chatbot </h2>
            {/* <p>
              <img src={cb} alt="Microsoft azure" style={{ height: "30px" }} />{" "}
              RAG Chatbot
            </p> */}
          </div>
        </div>
      </div>

      <section className="siw-rpa-section">
        <div className="siw-rpa-container-data-engineering container">
          <div className="siw-rpa-content">
            {/* <span className="siw-rpa-tag">
              Still Manually Searching item codes & rates in SOR (Schedule of
              Rates) documents?
            </span> */}

            <div className="siw-rpa-text">
              <p>
                Retrieval-Augmented Generation (RAG), a method designed to
                improve the accuracy of artificial intelligence. While a
                standard language model might provide a hallucinated response
                when relying solely on its internal training, this architecture
                utilizes an external knowledge-base to anchor the AI in reality.
                By converting a user’s question into a search query, the system
                identifies relevant data within a vector database and integrates
                those findings into an enhanced prompt. This process ensures
                that the language model receives specific, reliable context,
                ultimately allowing it to produce a factual response instead of
                an invented one.
              </p>
            </div>

            <div className="siw-rpa-desc">
              <h3 className="pb-2">Key Capabilities</h3>
              <p>
                A chatbot that uses SharePoint data and RAG to deliver accurate
                answers.
              </p>
              <p
                className="py-2"
                style={{ fontWeight: "bold", color: "#009999" }}
              >
                The Five-Step Workflow
              </p>
              <ol>
                <li>Enabling managed identity.</li>
                <li>Setting permissions for the indexer.</li>
                <li>Creating a Microsoft Entra application registration.</li>
                <li>Creating a data source and index.</li>
                <li>Configuring the indexer and checking its status.</li>
              </ol>
            </div>
          </div>

          <div className="siw-rpa-cta">
            <h4 style={{ color: "rgb(230, 233, 55)" }}>Free Trial Available</h4>
            <p>
              <span style={{ fontSize: "20px", fontWeight: "bold" }}>SiW</span>{" "}
              is currently offering a free trial session. <br />
              Our team will create a dedicated RAG Chatbot.
            </p>
            <p className="siw-project-website-text-top">
              To explore more about the <strong>RAG Chatbot</strong>
              <br />
              Click 👉{" "}
              <a
                href="https://agents.siw.sg/"
                target="_blank"
                rel="noopener noreferrer"
                className="siw-project-website-link blinking1"
              >
                RAG Chatbot
              </a>
              .
            </p>
            <a href="/contact" className="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Start a Free Trial
            </a>
          </div>
        </div>
      </section>
      <div className="container" style={{ marginTop: "-10px" }}>
        <div className="siw-rpa-desc mt-0">
          <h3>Architecture</h3>
          <p className="pt-2">
            This documentation explores the security requirements for
            Retrieval-Augmented Generation (RAG) systems that serve multiple
            distinct customers simultaneously. It explains how these
            architectures use orchestration layers to provide artificial
            intelligence models with private, proprietary data that is not
            available on the public internet. The primary focus is on
            maintaining strict data isolation, ensuring that individuals can
            only access the specific information they are legally authorized to
            view. By analyzing the transition from single-tenant to multitenant
            environments, the text identifies potential vulnerabilities in
            shared data stores. Ultimately, the source provides strategic
            recommendations and best practices to safeguard sensitive
            information within complex, multi-user AI applications.
          </p>
          <img
            src={architecture2}
            alt="Architecture 2"
            className="siw-rpa-desc-img"
          />
          {/* <div className="row g-3 mt-2">
            <div className="col-md-6 ">
              <img
                src={architecture}
                alt="Architecture 1"
                className="siw-rpa-desc-img mx-0"
                style={{ width: "600px" }}
              />
            </div>

            <div className="col-md-6">
              <img
                src={architecture2}
                alt="Architecture 2"
                className="siw-rpa-desc-img"
              />
            </div>
          </div> */}
        </div>
      </div>

      <section className="siw-project-section">
        <div className="siw-project-container container">
          <div className="row g-4 align-items-start">
            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading mt-md-0 mt-4">
                Introducing RAG Chatbot
              </h3>

              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/Ti4ZfhMmqbY?si=vj2kI6KR61oUuZHG"
                  title="Introducing RAG Chatbot"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">Watch a Demo Video</h3>

              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/5IEtoxPXRoM?si=HzdaeCpBXIuypXhz"
                  title="Watch a Demo Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
          <p className="siw-project-website-text">
            To explore more about the <strong>RAG Chatbot</strong>, Click 👉{" "}
            <a
              href="https://agents.siw.sg/"
              target="_blank"
              rel="noopener noreferrer"
              className="siw-project-website-link blinking"
            >
              RAG Chatbot
            </a>
            .
          </p>
        </div>
      </section>
      <FooterOne></FooterOne>
    </>
  );
};
export default Rag;
